import React from "react";
import {useTranslation} from "react-i18next";
import {useAccount} from "../../../../../context/AccountContext";
import {useAuth} from "../../../../../context/AuthContext";
import {useNavigate} from "react-router-dom";
import CustomFitty from "./CustomFitty";

const CurrentInformationComponent = ({userData, hasUpgradeCTA}) => {

    const {t} = useTranslation();

    let account = useAccount();
    const {setCheckLoggedIn} = useAuth();

    let navigate = useNavigate();


    const onUpgrade = () => {
        setCheckLoggedIn(false);
        account.clearSessionCoupon();
        navigate("/PickProgram");
    };

    return (<>
        <div className={"package-wrapper"}>
            <div className={`package`}>
                <CustomFitty maxSize={20} minSize={12}>
                    {userData?.subscription?.product?.displayName}
                </CustomFitty>
            </div>
            {hasUpgradeCTA &&
                <button className={"upgrade-cta"} onClick={onUpgrade}>
                    <span>
                        {t("accountProductChangeCTA")}
                    </span>
                </button>
            }
        </div>
    </>)
}

export default CurrentInformationComponent;